export default "__VITE_ASSET__DVEgqAzp__"